<template>
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1257_1433)">
      <path
        d="M32.9504 7.98472L32.4118 8.15546L29.5436 8.411L28.7334 9.70474L28.1456 9.51795L25.8629 7.45989L25.5318 6.38961L25.0883 5.24828L23.6536 3.96142L21.9611 3.63025L21.9221 4.40489L23.5803 6.02292L24.3916 6.97861L23.4794 7.45531L22.7369 7.23644L21.6242 6.77234L21.662 5.8751L20.2021 5.27464L19.7174 7.38426L18.246 7.71772L18.3916 8.89458L20.3087 9.26356L20.6399 7.38312L22.2224 7.61688L22.958 8.04775H24.1383L24.9462 9.66578L27.0879 11.8384L26.9309 12.683L25.204 12.4629L22.2201 13.9698L20.0715 16.547L19.7919 17.6883H19.0207L17.5837 17.026L16.188 17.6883L16.5352 19.1608L17.1425 18.4607L18.2105 18.4274L18.136 19.7498L19.0207 20.0088L19.9042 21.0011L21.3469 20.5955L22.9947 20.8556L24.9084 21.3701L25.8641 21.4824L27.4844 23.3216L30.6116 25.1608L28.5891 29.0248L26.4542 30.0172L25.6441 32.2254L22.5547 34.288L22.2258 35.4775C30.1234 33.5752 35.9985 26.4809 35.9985 17.9989C35.9962 14.2941 34.8732 10.8461 32.9504 7.98472Z"
        fill="#FFE400"
      />
      <path
        d="M20.0705 27.4068L18.7596 24.9763L19.9628 22.4691L18.7596 22.1092L17.4085 20.7525L14.4154 20.081L13.4219 18.0023V19.2364H12.9842L10.4047 15.7391V12.8663L8.51394 9.79183L5.51165 10.327H3.48912L2.47155 9.66005L3.76986 8.63102L2.47498 8.9301C0.91425 11.5955 0.00439453 14.6883 0.00439453 18.0011C0.00439453 27.9396 8.06131 36 18.001 36C18.7664 36 19.517 35.9324 20.2596 35.843L20.0716 33.6623C20.0716 33.6623 20.8978 30.424 20.8978 30.314C20.8967 30.2028 20.0705 27.4068 20.0705 27.4068Z"
        fill="#5EB24A"
      />
      <path
        d="M6.69203 5.80405L9.88913 5.35829L11.3628 4.55042L13.0209 5.02827L15.6703 4.88159L16.5778 3.45493L17.9014 3.67265L21.1156 3.37128L22.0014 2.39496L23.2505 1.56073L25.0175 1.82659L25.6615 1.72918C23.3341 0.63369 20.7444 0 17.9999 0C12.4136 0 7.41854 2.54622 4.12061 6.54431H4.12977L6.69203 5.80405ZM18.7608 1.78992L20.5988 0.778075L21.7791 1.45989L20.0706 2.7605L18.4388 2.92437L17.7043 2.44767L18.7608 1.78992ZM13.3166 1.93774L14.1279 2.27578L15.1901 1.93774L15.7688 2.94041L13.3166 3.58442L12.1374 2.89458C12.1374 2.89458 13.2902 2.15202 13.3166 1.93774Z"
        fill="#5EB24A"
      />
    </g>
    <defs>
      <clipPath id="clip0_1257_1433">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {};
</script>
